import styled from "@emotion/styled";
import * as React from "react";

import { ChevronDown, ChevronUp } from "@livechat/design-system-icons";
import {
  ActionMenu,
  ActionMenuItem,
  Button,
  IActionMenuOption,
  Icon,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import { TicketStatus, TicketStatusFormattedValues } from "interfaces/entities/ticket";
import { withVar } from "themes/helpers";

interface IProps {
  status: TicketStatus;
  isPrivate: boolean;
  onChange(status: TicketStatus): void;
  onMouseDown(e: React.MouseEvent<HTMLDivElement>): void;
}

interface IState {
  dropdownVisible: boolean;
}

const TicketStatusLabel = styled(Text)`
  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    display: none;
  }
`;

export class TicketStatusDropdown extends React.PureComponent<IProps, IState> {
  state = {
    dropdownVisible: false,
  };

  handleButtonClick = (): void => {
    this.setState(prevState => ({
      dropdownVisible: !prevState.dropdownVisible,
    }));
  };

  handleClose = (): void => {
    this.setState({ dropdownVisible: false });
  };

  handleSelect = (itemKey: TicketStatus): void => {
    this.props.onChange(itemKey);
    this.handleClose();
  };

  private getOptions: IActionMenuOption[] = [
    TicketStatus.Open,
    TicketStatus.Pending,
    TicketStatus.OnHold,
    TicketStatus.Solved,
    TicketStatus.Closed,
  ].map(ticketStatus => ({
    key: ticketStatus,
    element: <ActionMenuItem>{TicketStatusFormattedValues[ticketStatus]}</ActionMenuItem>,
    onClick: () => this.handleSelect(ticketStatus),
  }));

  render(): JSX.Element {
    const { status, onMouseDown } = this.props;
    const { dropdownVisible } = this.state;

    return (
      <Flex
        alignItems="center"
        marginRight={withVar(SpacingToken.Spacing2)}
        gap={withVar(SpacingToken.Spacing2)}
        onMouseDown={onMouseDown}
      >
        <TicketStatusLabel size="sm">Ticket status</TicketStatusLabel>
        <ActionMenu
          visible={dropdownVisible}
          selectedOptions={[status]}
          placement="top-start"
          onClose={this.handleClose}
          options={this.getOptions}
          triggerRenderer={
            <Button
              size="compact"
              kind="secondary"
              onClick={this.handleButtonClick}
              iconPosition="right"
              icon={<Icon source={dropdownVisible ? ChevronUp : ChevronDown} />}
            >
              {TicketStatusFormattedValues[status]}
            </Button>
          }
        />
      </Flex>
    );
  }
}
